module.exports = __webpack_public_path__ + "img/triell-1.16c36c32.png";